<ng-template #loadingGeneral>

  <mat-spinner class="center"></mat-spinner>
  <p class="center">Loading...</p>

</ng-template>

<ng-template #loadingItem>
  <mat-progress-bar class="center" mode="indeterminate"></mat-progress-bar>
</ng-template>


<div fxLayout="column">


  <ng-container *ngIf="dataSource; else loadingGeneral">


    <div class="w-100 mb-1" fxLayout="row" fxLayoutAlign="center center">

      <mat-form-field *ngIf="dataSource.data.length > 1" class="mb-0">
        <mat-label>Search</mat-label>
        <input #input (keyup)="applyFilters(input.value)" (keyup.escape)="input.value = ''; applyFilters('')" matInput
          placeholder="">
      </mat-form-field>
      <span fxFlex></span>
    </div>


    <mat-progress-bar *ngIf="loading" class="center" mode="indeterminate"></mat-progress-bar>
    <table (matSortChange)="doSortContractEvents($event)" [dataSource]="dataSource" class="w-100 mat-elevation-z2"
      mat-table multiTemplateDataRows matSort>

      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

      <!-- Position Column -->
      <ng-container matColumnDef="id">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
        <td *matCellDef="let element" mat-cell> {{element.id}} </td>
      </ng-container>

      <!-- Date Column -->
      <ng-container matColumnDef="timestamp">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Date</th>
        <td *matCellDef="let element" mat-cell> {{element.timestamp | date:"dd/MM/yyyy"}} </td>
      </ng-container>

      <!-- Applied Contract Status Column -->
      <ng-container matColumnDef="appliedState">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Applied Contract Status</th>
        <td *matCellDef="let element" mat-cell> {{element.appliedState | splitCamelCase}} </td>
      </ng-container>

      <!-- Previous Contract Status Column -->
      <ng-container matColumnDef="previousState">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Previous Contract Status</th>
        <td *matCellDef="let element" mat-cell> {{element.previousState | splitCamelCase}} </td>
      </ng-container>

      <!-- Contract Event Type Column -->
      <ng-container matColumnDef="createdBy">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Applied By</th>
        <td *matCellDef="let element" mat-cell> {{element.appliant}} </td>
      </ng-container>

      <!-- Action -->
      <ng-container matColumnDef="action">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let element" mat-cell class="text-right">
          <ng-container *ngIf="!disabledItemId.includes(element.id); else loadingItem">
            <button (click)="details(element)" [disabled]="disabled" mat-icon-button matTooltip="Show details">
              <mat-icon>visibility</mat-icon>
            </button>
          </ng-container>
        </td>
      </ng-container>


      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns:  displayedColumns" mat-row></tr>

      <tr *matNoDataRow class="mat-row">
        <td [colSpan]="displayedColumns.length" class="mat-cell text-center">
          No history found for this contract
        </td>
      </tr>

    </table>
  </ng-container>

  <mat-paginator #paginatorContractEvents [fxShow]="dataSource && dataSource.data.length > 10" class="mat-elevation-z1"
    [pageSizeOptions]="[5, 10, 20]" [pageSize]="10" showFirstLastButtons></mat-paginator>
</div>